import { createRouter } from '@tanstack/react-router';
import { I18nextProvider } from 'react-i18next';
import { routeTree } from './routeTree.gen';
import i18n from '@/lib/i18n';

export const getRouter = () => {
	return createRouter({
		routeTree,
		defaultPreload: 'intent',
		scrollRestoration: true,
		defaultViewTransition: true,
		defaultPreloadStaleTime: 30000,
		defaultPreloadGcTime: 30000,
		Wrap: ({ children }) => {
			return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
		},
	});
};
